<canvas class="nonogram-preview">
</canvas>